module.exports = __webpack_public_path__ + "1e39f60c31a5d03f90ffd6a2bc0f35a2.fbx";